export default "/fonts/icon-font.woff2?be809ed65903f2789b79535777f519aa";